#import "../fragments/inbox-status-fragment.graphql"

query GetInboxStatus {
    inboxStatus {
        ...InboxStatusFragment
    }
}
